"use client";

import { createContext, useContext, ReactNode, useState } from "react";

type TabContextType = {
  activeTab: number;
  setActiveTab: (index: number) => void;
  tabs: { label: string; dlt: string; dld: string; tabContent: ReactNode }[];
  theme?: "black" | "gray" | "white";
};

const TabContext = createContext<TabContextType>({
  activeTab: 0,
  setActiveTab: () => {},
  tabs: [],
  theme: "gray",
});

export const useTabContext = () => {
  const context = useContext(TabContext);
  return context;
};

type TabProviderProps = {
  children: ReactNode;
  tabs: { label: string; dlt: string; dld: string; tabContent: ReactNode }[];
  theme?: "black" | "gray" | "white";
  initialActiveTab?: number;
};

export const TabProvider = ({
  children,
  tabs,
  theme = "gray",
  initialActiveTab = 0,
}: TabProviderProps) => {
  const [activeTab, setActiveTab] = useState(
    initialActiveTab >= 0 && initialActiveTab < tabs.length
      ? initialActiveTab
      : 0,
  );

  const value = {
    activeTab,
    setActiveTab,
    tabs,
    theme,
  };

  return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
};
